import * as Yup from "yup";

export const searchSchema = Yup.object().shape({
  raison_social: Yup.string().max(50, "Trop longue!"),
  assurtrad_id: Yup.string().max(50, "Trop longue!"),
  activity: Yup.string().max(50, "Trop longue!"),
  country_id: Yup.string().max(50, "Trop longue!"),
});

